import $ from 'jquery';

$(function () {
    if ($('#brand_home_page').length) {
        toggleHeroImageFilter();

        $(window).on('scroll', function (e) {
            toggleHeroImageFilter();
        });

        $('#scroll_down').on('click', (e) => {
            $("html, body").stop().animate({scrollTop:e.currentTarget.offsetTop}, 500, 'swing')
        });

        setTimeout( () => {
            $('#home_page .filter').css('width', '100%');
        }, 250);
    }

    if ($('#my_site_page').length) {
        $(document).ready(function () {
            var value = $("#hidBackgroundTheme").val();
            console.log("hidBackgroundTheme on load: " + value);
            setBackground();
        });
    }

    if ($('#branch_page').length) {
        $(document).ready(function () {
            var value = $("#hidBackgroundTheme").val();
            console.log("hidBackgroundTheme on load: " + value);
            setBackground();
        });
    }

    function toggleHeroImageFilter() {
        if (window.scrollY > window.innerHeight) {
            $('.home-hero-section').addClass('blured');
        }
        else {
            $('.home-hero-section').removeClass('blured');
        }
    }
});

function setBackground() {
    if ($("#hidBackgroundTheme").val() == "dark") {
        $("#sctInfoSection").css("background-image", "url(" + $("#sctInfoSection").data("dark") + ")");
        $("#sctInfoSection").css("background-position", "center center");
    }
    else if ($("#hidBackgroundTheme").val() == "light") {
        $("#sctInfoSection").css("background-image", "url(" + $("#sctInfoSection").data("light") + ")");
        $("#sctInfoSection").css("background-position", "center center");
    }
    else if ($("#hidBackgroundTheme").val() == "transparent") {
        $("#sctInfoSection").css("background-image", "url(" + $("#sctInfoSection").data("transparent") + ")");
        $("#sctInfoSection").css("background-position", "center center");
    }
    else if ($("#hidBackgroundTheme").val() == "default") {
        $("#sctInfoSection").css("background-image", "url(" + $("#sctInfoSection").data("default") + ")");
    }
}